import { render, staticRenderFns } from "./housekeepingServFeeConfigManageRel.vue?vue&type=template&id=7318a505&scoped=true"
import script from "./housekeepingServFeeConfigManageRel.vue?vue&type=script&lang=js"
export * from "./housekeepingServFeeConfigManageRel.vue?vue&type=script&lang=js"
import style0 from "./housekeepingServFeeConfigManageRel.vue?vue&type=style&index=0&id=7318a505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7318a505",
  null
  
)

export default component.exports